import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_FORMS_REQUEST = 'GET_FORMS_REQUEST';
export const GET_FORMS_SUCCESS = 'GET_FORMS_SUCCESS';
export const GET_FORMS_FAILURE = 'GET_FORMS_FAILURE';

function requestGetForms() {
  return {
    type: GET_FORMS_REQUEST,
    isGettingForms: true
  };
}

function receiveGetForms(forms, formsCount) {
  return {
    type: GET_FORMS_SUCCESS,
    isGettingForms: false,
    forms,
    formsCount
  };
}

function rejectGetForms() {
  return {
    type: GET_FORMS_FAILURE,
    isGettingForms: false
  };
}

export function getForms(pageNumber, pageSize, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formTypes) {
  return (dispatch) => {
    dispatch(requestGetForms());
    const promise = () => ApiService
      .getForms(pageNumber, pageSize, sortByField, sortDirection, filterList, searchQuery, legalEntity, legalEntitySelected, accountNumber, accountNumberSelected, customer, customerSelected, formTypes)
      .then((response) => {
        dispatch(receiveGetForms(response.data.items, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetForms, true));
        }
      });
    return promise();
  };
}

export function getFormsByObject(requestObject) {
  return getForms(
    requestObject.pageNumber,
    requestObject.pageSize,
    requestObject.sortByField,
    requestObject.sortDirection,
    requestObject.filterList,
    requestObject.searchQuery,
    requestObject.legalEntity,
    requestObject.legalEntitySelected,
    requestObject.accountNumber,
    requestObject.accountNumberSelected,
    requestObject.customer,
    requestObject.customerSelected,
    requestObject.formTypes
  );
}
